import { render, staticRenderFns } from "./addGameStyle.vue?vue&type=template&id=30b2c5ea&"
import script from "./addGameStyle.vue?vue&type=script&lang=js&"
export * from "./addGameStyle.vue?vue&type=script&lang=js&"
import style0 from "./addGameStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b2c5ea')) {
      api.createRecord('30b2c5ea', component.options)
    } else {
      api.reload('30b2c5ea', component.options)
    }
    module.hot.accept("./addGameStyle.vue?vue&type=template&id=30b2c5ea&", function () {
      api.rerender('30b2c5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addGameStyle.vue"
export default component.exports